export const commonBook = {
  termsPrivacy: '/terms-privacy',
  terms: '/terms-conditions',
  privacy: '/privacy-policy',
  checkYouEmail: '/check-you-email',
  setNewPassword: '/set-new-password',
  adminView: '/admin-view',
  // INJECT
};
